export default {
  title: '選擇生產批次',
};
